import { render, staticRenderFns } from "./scroll-indicator.vue?vue&type=template&id=4b279df4&scoped=true&"
import script from "./scroll-indicator.vue?vue&type=script&lang=js&"
export * from "./scroll-indicator.vue?vue&type=script&lang=js&"
import style0 from "./scroll-indicator.vue?vue&type=style&index=0&id=4b279df4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b279df4",
  null
  
)

export default component.exports